import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-pagenotfound',
  templateUrl: './pagenotfound.component.html',
  styleUrls: ['./pagenotfound.component.css'],
})
export class PagenotfoundComponent implements OnInit, OnDestroy {
  constructor() {}

  ngOnInit(): void {
    var sideNav = <HTMLElement>document.querySelector('.sideNav');
    sideNav.style.visibility = 'hidden';
  }

  ngOnDestroy() {
    var sideNav = <HTMLElement>document.querySelector('.sideNav');
    sideNav.style.visibility = 'visible';
  }
}
